module.exports = __webpack_public_path__ + "img/diseases.e7495725.svg";